<template>
    <div>
        <div layout-gt-md="row" layout-align="start stretch" class="mt-1" layout-wrap>
            <v-card class="panel half bg-white ml-0 mr0-mobile">
                <v-card-text>
                    <p class="title">{{ $t('schools.info') }}</p>

                    <div layout="column">
                        <div layout="row">
                            <span flex="35" class="font-weight-medium">{{ $t('schools.name') }} :</span>
                            <span>{{ school.name }}</span>
                        </div>

                        <div layout="row">
                            <span flex="35" class="font-weight-medium">{{ $t('params.sectors') }} :</span>
                            <span v-for="(s,i) in school.sectors" :key="s.id">{{ sectors[s.sector] }}{{ i == (school.sectors.length - 1) ? '' : ',&nbsp; '}}</span>
                        </div>

                        <div v-if="school.regional_directorate" layout="row">
                            <span flex="35" class="font-weight-medium">{{ $t('params.rd') }} :</span>
                            <span>{{ i18n(school.regional_directorate.label) }}</span>
                        </div>

                        <div v-if="school.region" layout="row">
                            <span flex="35" class="font-weight-medium">{{ $t('params.region') }} :</span>
                            <span>{{ i18n(school.region.name) }}</span>
                        </div>

                        <div layout="row">
                            <span flex="35" class="font-weight-medium">{{ $t('schools.address') }} :</span>
                            <span>
                            <span v-if="school.street_number">
                                {{ school.street_number }},
                            </span>
                            {{ school.street_name }}
                            <br v-if="school.street_number || school.street_name">
                            <span v-if="school.zip_code">
                                {{ school.zip_code }}
                            </span>
                            {{ school.city.label }}
                            </span>
                        </div>
                    </div>
                </v-card-text>
            </v-card>

            <v-card class="panel half bg-white mr-0 ml0-mobile">
                <v-card-text>
                    <p class="title">{{ $t('schools.contact') }}</p>

                    <div layout="row">
                        <span flex="35" class="font-weight-medium">{{ $t('schools.fullname') }} :</span>
                        <span>{{ school.contact_fullname }}</span>
                    </div>

                    <div layout="row">
                        <span flex="35" class="font-weight-medium">{{ $t('schools.email') }} :</span>
                        <span class="break-word">{{ school.contact_email }}</span>
                    </div>

                    <div layout="row">
                        <span flex="35" class="font-weight-medium">{{ $t('schools.phone1') }} :</span>
                        <span>{{ school.contact_phone }}</span>
                    </div>

                    <div layout="row">
                        <span flex="35" class="font-weight-medium">{{ $t('schools.phone2') }} :</span>
                        <span>{{ school.contact_phone2 }}</span>
                    </div>

                    <div layout="row">
                        <span flex="35" class="font-weight-medium">{{ $t('schools.function') }} :</span>
                        <span>{{ school.contact_function }}</span>
                    </div>

                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
    import Consts from '@/consts'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        props: {
            school: {
                required: true,
                type: Object,
                default () {
                    return { city: {} }
                }
            }
        },
        data () {
            return {

            }
        },
        mounted () {

        },
        methods: {

        },
        computed: {
            sectors () {
                let arr = [];
                arr[Consts.PRIMARY] = this.$t('schools.sector_prim');
                arr[Consts.SECONDARY] = this.$t('schools.sector_sec');
                arr[Consts.COMPETENCECENTRE] = this.$t('schools.sector_comp');
                return arr;
            },
        }
    }
</script>
<style scoped>
.panel {
  /*border-top: 4px solid #888888;*/
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 16px;
}

@media screen and (max-width: 960px) {
  .panel {
    margin-left: 0px;
    margin-right: 0px;
  }
}

@media screen and (min-width: 1280px) {
  .panel.half {
    width: calc(50% - 4px);
  }

  .panel.third {
    width: calc(33.33333% - 4px);
  }
}
</style>